import { InlineButton, Paragraph, Row } from '@fs/zion-ui'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { GedcomInfoSheet } from '@fs/zion-controlled-edit-trees'
import { useGroupsContext } from '@fs/zion-tree-groups'
import { useGedcomData } from '../../providers/GedcomDataProviderSmart'
import { useGedcomInfoSheets } from '../providers/GedcomInfoSheetProvider'

export default function UploadReport(): JSX.Element | null {
  const [t] = useTranslation()
  const { gedcomData, refetchGedcomData } = useGedcomData()
  const { treeDetails } = useGroupsContext()
  const { gedcomErrorsInfoSheet } = useGedcomInfoSheets()
  const hasDifferences =
    treeDetails && !treeDetails.hidden && gedcomData && gedcomData.errorCount > 0 && !gedcomData.errorReviewDone

  if (!hasDifferences) return null

  return (
    <>
      <Row wrap alignY="middle" gutters="xs">
        <Paragraph size="sm">
          <Trans i18nKey="group-management.upload-report.heading" values={{ number: gedcomData.errorCount }} />
        </Paragraph>

        <InlineButton data-testid="review-errors" onClick={gedcomErrorsInfoSheet.handleClick}>
          {t('group-management.review.action')}
        </InlineButton>
      </Row>

      <GedcomInfoSheet
        fileName={gedcomData.fileName}
        infoSheet={gedcomErrorsInfoSheet}
        onDoneReviewing={refetchGedcomData}
      />
    </>
  )
}
